import React from 'react';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';
import config from '../../config';

// Components
import Search from '../Search';
import Logo from '../Logo';

import {
  StyledHeader,
  Heading,
  TagLine,
  HeadingWrap
} from './HeaderStyles.js';

const Header = ({ light }) => (
  <StyledHeader>
    {!light && (<HeadingWrap>
      <Heading>
        <Logo size={32}></Logo>
        toomanykiwis
      </Heading>
      <TagLine>{config.TAG_LINE}</TagLine>
    </HeadingWrap>)}
    <Search></Search>
  </StyledHeader>
);

Header.propsTypes = {
  light: PropTypes.bool
};

Header.defaultProps = {
  light: true
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx